const updateSelectedMembership = (state, { payload: { membership } }) => {
	state.selectedMembership = membership;
};

export default updateSelectedMembership;
